import { cn } from "@/lib/utils";

const STYLES = {
  faible: "bg-emerald-50 text-emerald-700 border-emerald-200",
  moyenne: "bg-yellow-50 text-yellow-800 border-yellow-200",
  critique: "bg-rose-50 text-rose-700 border-rose-200",
};
const LABELS = {
  faible: "Faible",
  moyenne: "Moyenne",
  critique: "Critique",
};

export default function SeverityBadge({ severity, className, testId }) {
  const style = STYLES[severity] || STYLES.moyenne;
  const label = LABELS[severity] || severity;
  return (
    <span
      data-testid={testId || `severity-badge-${severity}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border",
        style,
        className,
      )}
    >
      {label}
    </span>
  );
}
